<template>
	<div class="id">
		<img class="bgImg" src="/img/imgBg1.jpg">
		<div class="register">
			<van-nav-bar class="nav-bars">
				<template #left>
					<van-icon name="arrow-left" color="#fff" @click="back()" />
				</template>
			</van-nav-bar>
			<div class="wrapper">
				<img :src="logo" class="imgBox" v-if="logo"/>
				<div v-else class="imgBox"></div>
				<div class="title">{{$t("auth.title")}}</div>
				<div class="loginForm">
					<van-field v-model="username" clearable input-align="center" class="input"
						:placeholder="$t('auth.username_place')" />
					<van-field v-model="password" :type="passwordType" input-align="center" class="input"
						:placeholder="$t('auth.pwd_place')">
						<template slot="right-icon">
							<van-icon :name="passwordType === 'password' ? 'closed-eye':'eye-o'"
								@click="switchPasswordType" />
						</template>
					</van-field>
					<van-field v-model="code" clearable input-align="center" class="input"
						:placeholder="$t('auth.invite_code_place')" />
					<van-checkbox v-model="checked" icon-size="22px" class="checkedbtc">
						{{$t("recharge.xy_info")}}
					</van-checkbox>
					<van-button class="login-btn" type="primary" size="normal"
						@click="doRegister()">{{$t("auth.register")}}</van-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				checked: true,
				username: '',
				code: '',
				password: '',
				passwordType: 'password',
				logo: ''
			};
		},
		mounted() {
			this.getBaseInfo()
		},
		methods: {
			getBaseInfo() {
				this.$http({
					method: 'get',
					url: 'base_info'
				}).then(res => {
					this.logo = res.data.logo
				})
			},
			switchPasswordType() {
				this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
			},
			back() {
				return window.history.back();
			},
			doRegister() {

				if (!this.checked) {
					this.$toast(this.$t("auth.agreement"));
					return false;
				}
				this.$http({
					method: 'post',
					data: {
						username: this.username,
						password: this.password,
						invite_code: this.code,
					},
					url: 'register'
				}).then(res => {
					if (res.code == 1) {

						localStorage.setItem('token', res.data.userinfo.token)
						this.$router.push("Mine")
					} else {
						this.$toast.fail(res.msg);
					}
				})
			}
		},

	};
</script>

<style lang='less' scoped>
	::v-deep .van-checkbox__label {
		padding-top: 30px;
		height: 100px;
		line-height: 30px !important;
		font-size: 28px;
		color: #fff;
	}
	.nav-bars {
		background-color: rgba(255, 255, 255, 0) !important;
	}

	.id {
		position: relative;
		min-height: 100vh;

		.bgImg {
			position: absolute;
			top: 0;
			right: 0;
			object-fit: cover;
			height: 100%;
			width: 100%;
		}

		.register {
			width: 100%;
			min-height: 100vh;
			background: linear-gradient(hsla(0, 0%, 100%, 0), #f905e5);
			position: absolute;
			top: 0;
			right: 0;
			z-index: 1;

			.language {
				position: absolute;
				top: 10px;
				right: 40px;
				height: 62px;

				img {
					height: 100%;
				}
			}

			.wrapper {
				.imgBox {
					margin-top: 20px;
					width: 200px;
					height: 200px;
					margin: 0 auto;
					display: block;
				}

				.title {
					line-height: 100px;
					text-align: center;
					font-size: 45px;
					font-weight: 700;
					color: #fff;
					letter-spacing: 5px;
				}

				.loginForm {
					padding: 60px;

					.input {
						padding: 10px 20px;
						margin-top: 40px;
						border-radius: 50px;
						text-align: center;
						line-height: 80px;
						font-size: 30px;
						color: #4e4e4e;

						::v-deep .van-icon {
							font-size: 50px;
						}
					}


					.login-btn {
						margin-top: 85px;
						width: 100%;
						height: 100px;
						border-radius: 50px;
						color: #fff;
						background: linear-gradient(90deg, #c24491, #775fd9);
						font-size: 30px;
						font-weight: bolder;
						border: none;
					}
				}
			}
		}
	}
</style>